import search from './modules/store'

export const modules = {
  search
}



// WEBPACK FOOTER //
// ./src/store/Search/index.js